export const getBrowserSessionId = () => {
  const bank_verification_id = 'bank_verification_session_id';

  let sessionId = sessionStorage.getItem(bank_verification_id);

  if (!sessionId) {
    sessionId = crypto.randomUUID(); // native UUID v4
    sessionStorage.setItem(bank_verification_id, sessionId);
  }

  return sessionId;
};
